import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-brand-dark text-white pt-12 pb-6 mt-auto">
      <div className="container-custom">
        {/* Top row: logo + description */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2">
              <svg width="36" height="36" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 4L28 16L16 28L4 16L16 4Z" fill="#FFFFFF" />
                <path d="M16 8L24 16L16 24L8 16L16 8Z" fill="#C41230" />
              </svg>
              <span className="font-bold text-xl text-white tracking-tight">Voting Data API</span>
            </div>
            <p className="text-gray-400 text-sm mt-3 max-w-md">
              Система збору та публікації структурованих даних про голосування органів влади
            </p>
          </div>
        </div>

        {/* Middle row: resources + legal links */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 border-t border-gray-800 pt-8">
          <div>
            <h4 className="font-semibold text-white mb-3">Ресурси</h4>
            <ul className="space-y-2">
              <li><Link to="/docs" className="text-gray-400 hover:text-white text-sm transition-colors">Документація API</Link></li>
              <li><Link to="/#api" className="text-gray-400 hover:text-white text-sm transition-colors">API Reference</Link></li>
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">GitHub</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-3">Правова інформація</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Умови використання</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Політика конфіденційності</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Provenance даних</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar: only copyright */}
        <div className="border-t border-gray-800 pt-6 text-center text-gray-400 text-xs">
          © 2025 Проєкт "Перезарядити країну тобі під силу" за підтримки NED
        </div>
      </div>
    </footer>
  );
};

export default Footer;